/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getImplants } from 'app/entities/implant/implant.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPatientProcedureOrders } from 'app/entities/patient-procedure-order/patient-procedure-order.reducer';
import { createEntity, getEntity, reset, updateEntity } from './patient-procedure-implant.reducer';

export const PatientProcedureImplantUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const implants = useAppSelector(state => state.implant.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const patientProcedureOrders = useAppSelector(state => state.patientProcedureOrder.entities);
  const patientProcedureImplantEntity = useAppSelector(state => state.patientProcedureImplant.entity);
  const loading = useAppSelector(state => state.patientProcedureImplant.loading);
  const updating = useAppSelector(state => state.patientProcedureImplant.updating);
  const updateSuccess = useAppSelector(state => state.patientProcedureImplant.updateSuccess);

  const handleClose = () => {
    navigate(`/patient-procedure-implant${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getImplants({}));
    dispatch(getGlucoUsers({}));
    dispatch(getPatientProcedureOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.quantity !== undefined && typeof values.quantity !== 'number') {
      values.quantity = Number(values.quantity);
    }

    const entity = {
      ...patientProcedureImplantEntity,
      ...values,
      implant: implants.find(it => it.id.toString() === values.implant?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      order: patientProcedureOrders.find(it => it.id.toString() === values.order?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...patientProcedureImplantEntity,
          implant: patientProcedureImplantEntity?.implant?.id,
          patient: patientProcedureImplantEntity?.patient?.id,
          order: patientProcedureImplantEntity?.order?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientProcedureImplant.home.createOrEditLabel" data-cy="PatientProcedureImplantCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientProcedureImplant.home.createOrEditLabel">
              Create or edit a PatientProcedureImplant
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-procedure-implant-id"
                  label={translate('tinyMedicRestApp.patientProcedureImplant.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.active')}
                id="patient-procedure-implant-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.cursor')}
                id="patient-procedure-implant-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.lastupdated')}
                id="patient-procedure-implant-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.microSec')}
                id="patient-procedure-implant-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.timestampentry')}
                id="patient-procedure-implant-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.quantity')}
                id="patient-procedure-implant-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.implanted')}
                id="patient-procedure-implant-implanted"
                name="implanted"
                data-cy="implanted"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.implantRemoved')}
                id="patient-procedure-implant-implantRemoved"
                name="implantRemoved"
                data-cy="implantRemoved"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureImplant.implantUrl')}
                id="patient-procedure-implant-implantUrl"
                name="implantUrl"
                data-cy="implantUrl"
                type="text"
              />
              <ValidatedField
                id="patient-procedure-implant-implant"
                name="implant"
                data-cy="implant"
                label={translate('tinyMedicRestApp.patientProcedureImplant.implant')}
                type="select"
                required
              >
                <option value="" key="0" />
                {implants
                  ? implants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="patient-procedure-implant-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.patientProcedureImplant.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-implant-order"
                name="order"
                data-cy="order"
                label={translate('tinyMedicRestApp.patientProcedureImplant.order')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedureOrders
                  ? patientProcedureOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-procedure-implant" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientProcedureImplantUpdate;
